export default {
  activateLandingPageTitle: 'Eventi',
  activateProductCardTitle: 'Eventi',
  activateProductPageTitle: 'Prenota eventi',
  allProductsLandingPageTitle: 'Prenota esperienze uniche',
  apply: 'Applica',
  buyTickets: 'Acquista biglietti',
  cancel: 'Annulla',
  clear: 'Cancella',
  clearFilters: 'Cancella filtri',
  discoverExperiences: 'Scopri esperienze',
  exclusive: 'Esclusivo',
  experience: 'esperienza',
  experiencePhotoOfListing:
    "Foto dell'esperienza {{photoNumber}} dell'annuncio {{listingTitle}}",
  experiences: 'esperienze',
  filterExperiences: 'Filtra esperienze',
  fromListingCard: 'Da',
  hostedBy: 'Ospitato da',
  hostLandingPageTitle: 'Esperienze locali',
  hostProductCardTitle: 'Esperienze locali',
  hostProductPageTitle: 'Prenota esperienze locali',
  landingPageTitle: 'Prenota esperienze uniche',
  mainLandingPageTitle: 'Tutte le esperienze',
  more: 'Altro',
  noExperiencesFound: 'Nessuna esperienza trovata',
  noExperiencesFoundFor: 'Nessuna esperienza trovata per',
  experiencesFoundCount: '{{count}} esperienze trovate',
  profileImageOfHost: 'Immagine del profilo di {{hostName}}',
  reserve: 'Prenota',
  reserveLandingPageTitle: 'Attività e servizi',
  reserveProductCardTitle: 'Attività',
  reserveProductPageTitle: 'Prenota attività e servizi',
  resultsPageTitle: 'Prenota esperienze e attività',
};
